import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  IResetPasswordKorisnikCommand,
  IResult,
  KorisniciClient,
  ResetPasswordKorisnikCommand,
  Result,
} from '@kodit/core/data-api';
import {
  ChangePasswordFormService,
  FormHelper,
} from '@kodit/core/form-definitions';
import { AlertService } from '@kodit/core/services';
import { DynamicDialogConfig, DynamicDialogRef } from '@kodit/core/shared-ui';
import { FormGroupTypeSafe } from 'angular-typesafe-reactive-forms-helper';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'kodit-change-password-form',
  templateUrl: './change-password-form.component.html',
  styleUrls: ['./change-password-form.component.scss'],
})
export class ChangePasswordFormComponent implements OnInit, OnDestroy {
  /** Subs */
  private _saveSub: Subscription = new Subscription();
  private _submitSub: Subscription = new Subscription();

  /** Props */
  form: FormGroupTypeSafe<IResetPasswordKorisnikCommand>;

  constructor(
    private _fs: ChangePasswordFormService,
    private _dialogRef: DynamicDialogRef,
    private _alertService: AlertService,
    private _client: KorisniciClient,
    private _formHelper: FormHelper,
    private _dialogConfig: DynamicDialogConfig
  ) {}

  ngOnInit(): void {
    this.form = this._fs.GetPasswordChangeFormGroup(
      this._dialogConfig.data.korisnikEmail
    );
    // subscribe on dialog save button
    this._submitSub = this._dialogRef.onSubmit.subscribe(() => {
      this.save();
    });
  }

  keyDownFunction(event: any) {
    if (event.keyCode === 13) {
      this.save();
    }
  }

  private save() {
    if (!this.form.valid) {
      this._formHelper.invalidateForm(this.form);
      return;
    }

    this._saveSub = this._client
      .resetPassword(new ResetPasswordKorisnikCommand(this.form.value))
      .subscribe(
        (result) => {
          this.blobToTextResult(result.data).subscribe((res) => {
            if (res.succeeded) {
              this._alertService.addSuccessMsg(
                'Lozinka je uspešno promenjena.'
              );
              this._dialogRef.close();
            } else {
              this._alertService.addFailedMsg(res.messages.join(', '));
            }
          });
        },
        (error) => {
          error.subscribe((e) => {
            this._alertService.addFailedMsg(e);
          });
        }
      );
  }

  blobToTextResult(blob: any): Observable<IResult> {
    return new Observable<IResult>((observer: any) => {
      if (!blob) {
        observer.next('');
        observer.complete();
      } else {
        let reader = new FileReader();
        let jsonResult: any;
        reader.onload = (event) => {
          let result: Result = new Result({ messages: [], succeeded: true });

          jsonResult = JSON.parse(reader.result as string);

          if (!jsonResult.succeeded) {
            if (jsonResult.messages) {
              jsonResult.messages.forEach((m: string) => {
                result.messages.push(m);
                result.succeeded = false;
              });
            } else {
              result.messages.push('Došlo je do nepoznate greške.');
              result.succeeded = false;
            }
          }

          observer.next(result);
          observer.complete();
        };
        reader.readAsText(blob);
      }
    });
  }

  ngOnDestroy(): void {
    this._submitSub.unsubscribe();
    this._saveSub.unsubscribe();
  }
}
